<template>
  <div>
    <div class="row">
      <div class="col-sm-7">
        <Hero>
          <h2 class="mr-5">
            {{ $t('message.testDrive.anythingElseHeader')
            }}<img :src="require('@/assets/fa/thought-balloon.svg')" width="22" height="22" class="mb-1 ml-2" alt="" />
          </h2>
        </Hero>
        <label for="comments" class="label mt-n2 mb-4">{{ $t('message.testDrive.anythingElseDescription') }}</label>
        <textarea id="comments" class="text-box" v-model="setComments" data-cy="commentTextArea"></textarea>
      </div>
      <div class="col-sm-5">
        <DriveTip class="mt-4 mt-sm-2 tip-container">
          <template slot="description">{{ $t('message.testDrive.anythingElseDriveTip') }}</template>
        </DriveTip>
      </div>
    </div>
    <mobialis-button class="cont-btn" data-cy="continueBtn" @click="submit">{{
      $t('message.common.continue')
    }}</mobialis-button>
  </div>
</template>
<script>
import Hero from '@/components/test-drive/Hero.vue';
import DriveTip from '@/components/test-drive/DriveTip.vue';
import log from '@/services/log';

export default {
  name: 'AnythingElse',
  components: {
    Hero,
    DriveTip,
  },
  methods: {
    async submit() {
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/updateLead');
        this.$router.push({
          name: `drive-request-submitted-${this.baseRoute}`,
        });
      } catch (err) {
        log('Error in Test-drive comments - Update Lead', err);
        this.$router.push({ name: `drive-error-${this.baseRoute}` });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
  computed: {
    setComments: {
      get() {
        return this.$store.state.testDrive.comments;
      },
      set(value) {
        this.$store.commit('testDrive/SET_COMMENTS', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.text-box {
  border-radius: 4px;
  border: 1px solid rgb(197, 205, 214);
  height: 120px;
  width: 100%;
  &:focus {
    border: 1px solid rgb(197, 205, 214);
    outline: 1px solid rgb(197, 205, 214);
  }
}
.cont-btn {
  margin-top: 20px;
  @media (min-width: 576px) {
    margin-top: 100px;
  }
}
.label {
  color: #4b5863;
}
</style>
